import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Col } from 'components/grid';
import Toggle from 'components/checkbox';
import Dropdown from 'components/dropdown';

import { reorder } from 'utils/arrayUtils';
import { sortOptions } from 'utils/arraysLists';

import {
  StyledCol,
  StyledColField,
  StyledHeader,
  DraggableListStyled,
} from './styles';

const FiltersList = ({ filters, setFilters, onSelect }) => {
  const { t } = useTranslation();

  const Header = () => (
    <StyledHeader>
      <StyledColField col={4}>
        Campos
      </StyledColField>
      <StyledCol col={2}>
        obrigatório
      </StyledCol>
      <StyledCol col={2}>
        seleção múltipla
      </StyledCol>
      <StyledCol col={2}>
        ordenação
      </StyledCol>
      <Col col={2} />
    </StyledHeader>
  );

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      filters,
      result.source.index,
      result.destination.index,
    );

    const orderedItems = items.map((item, index) => ({ ...item, order: index + 1 }));

    setFilters(orderedItems);
  };

  const getSortOption = (sortBy) => sortOptions.find((option) => option.value === sortBy);

  const setFilter = (newValue) => {
    setFilters(filters.map((item) => (item.field === newValue.field ? newValue : item)));
  };

  const FiltersContent = (props) => {
    const { item } = props;
    const {
      name, disableRequired, required, multiple, sortBy,
    } = item;

    const renderRequiredToggle = () => (
      <Toggle
        checked={required}
        onChange={() => setFilter({ ...item, required: !required })}
      />
    );

    return (
      <>
        <StyledColField col={4}>{name}</StyledColField>
        <StyledCol col={2}>
          {!disableRequired && renderRequiredToggle()}
        </StyledCol>
        <StyledCol col={2}>
          <Toggle
            checked={multiple}
            onChange={() => setFilter({ ...item, multiple: !multiple })}
          />
        </StyledCol>
        <StyledCol col={2}>
          <Dropdown
            value={getSortOption(sortBy)}
            options={sortOptions}
            onChange={(change) => setFilter({ ...item, sortBy: change.value })}
          />
        </StyledCol>
      </>
    );
  };

  FiltersContent.propTypes = {
    item: PropTypes.shape({
      name: PropTypes.string.isRequired,
      required: PropTypes.bool.isRequired,
      disableRequired: PropTypes.bool.isRequired,
      multiple: PropTypes.bool.isRequired,
      sortBy: PropTypes.string.isRequired,
    }).isRequired,
  };

  return (
    <DraggableListStyled
      id="filtersList"
      items={filters}
      Header={Header}
      Content={FiltersContent}
      selectLabel={t('common.remove')}
      onSelect={onSelect}
      onDragEnd={onDragEnd}
    />
  );
};

FiltersList.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  setFilters: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default FiltersList;
